<template>
<div class="flex flex-col justify-center text-center">
  <div class="flex justify-center">
    <div class="flex w-auto font-sans-serif
      justify-center mt-4">
      <div class="flex flex-col mr-4 lg:mr-10 text-center md:text-sm text-xs lg:text-base
      md:bg-white md:p-1 md:rounded-lg md:shadow-lg md:bg-opacity-75">
        <span class="flex font-black justify-center text-base lg:text-lg">
          {{ lessonsCounter }}
        </span>
        {{$t('student.lessons')}}
      </div>
      <div class="flex flex-col mr-10 text-center
      transform hover:scale-110 duration-300 text-xs md:text-sm lg:text-base
      md:bg-white md:p-1 md:rounded-lg md:shadow-lg md:bg-opacity-75"
        v-if="user">
        <router-link :to="pathTeachers">
          <span class="flex font-black justify-center text-base lg:text-lg">
            {{ teachersCounter }}
          </span>
          {{$t('student.teachers')}}
        </router-link>
      </div>
      <div class="mr-10 text-center text-xs md:text-sm lg:text-base
      transform hover:scale-110 duration-300 md:bg-white md:p-1
      md:rounded-lg md:shadow-lg md:bg-opacity-75" v-else>
        <span class="flex font-black pt-5 justify-center text-base lg:text-lg">
           {{ teachersCounter }}
          </span>
          {{$t('student.teachers')}}
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getStudentBySlug } from '@/services/StudentService';

export default {
  data() {
    return {
      student: {},
      isLogged: !this.$route.params.slug,
    };
  },

  created() {
    if (this.isLogged) {
      this.student = this.user.student;
      return;
    }
    this.getStudent();
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    pathTeachers() {
      if (this.student.id === this.user.student.id) {
        return '/student-dashboard/teachers';
      }
      return `/students/${this.student.slug}/teachers`;
    },

    lessonsCounter() {
      return this.student.lessons_counter ? this.student.lessons_counter : 0;
    },

    teachersCounter() {
      return this.student.teachers_counter ? this.student.teachers_counter : 0;
    },
  },

  methods: {
    getStudent() {
      getStudentBySlug(this.$route.params.slug).then(({ data }) => {
        this.student = data;
      });
    },
  },
};
</script>

<style scoped>
  .boxShadow3d{
    box-shadow: 1px 1px 0px #999,
                2px 2px 0px #999,
                3px 3px 0px #999,
                4px 4px 0px #999,
                5px 5px 0px #999,
                6px 6px 0px #999;
  }
</style>
